import { render, staticRenderFns } from "./SolveProblem.vue?vue&type=template&id=31d8cd29&scoped=true&"
import script from "./SolveProblem.vue?vue&type=script&lang=js&"
export * from "./SolveProblem.vue?vue&type=script&lang=js&"
import style0 from "./SolveProblem.vue?vue&type=style&index=0&id=31d8cd29&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d8cd29",
  null
  
)

export default component.exports